var Util = (function () {
    function Util() {
    }
    Util.isNotPresent = function (control) {
        var value = control.value;
        if (value === undefined || value === null) {
            return true;
        }
        return value !== '' ? false : true;
    };
    ;
    Util.addError = function (control, errorId, value) {
        if (!control.errors) {
            control.setErrors((_a = {}, _a[errorId] = value, _a));
        }
        else if (!control.hasError(errorId)) {
            control.errors[errorId] = value;
        }
        var _a;
    };
    Util.removeError = function (control, errorId) {
        if (control.errors && control.hasError(errorId)) {
            delete control.errors[errorId];
        }
    };
    return Util;
}());
export { Util };
//# sourceMappingURL=util.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ngx-validators/src/util.js
// module id = null
// module chunks = 